import CommunitySetupDetails from "./CommunitySetupDetails";

export default CommunitySetupDetails;